export default {
  'download_format_modal_title': '下载设置',
  'download_format_modal_Metrics': '指标',
  'download_format_modal_Data': '数据变化',
  'download_format_modal_Data_Statistics': '数据统计',
  'download_format_modal_File_Format': '文件格式',
  'download_format_modal_Excel': 'Excel',
  'download_format_modal_CSV': 'CSV',
  'download_format_modal_Value_Only': '仅指标值',
  'download_format_modal_Value_and_DoD_Day': '指标值和环比',
  'download_format_modal_Value_and_DoD_Week': '指标值和环比',
  'download_format_modal_Value_and_DoD_Month': '指标值和环比',
  'download_format_modal_Value_and_SDLW_Day': '指标值和同比',
  'download_format_modal_Value_and_SDLW_Week': '指标值和同比',
  'download_format_modal_Value_and_SDLW_Month': '指标值和同比',
  'download_format_modal_Confirm': '确定',
  'download_format_modal_Cancel': '取消',
  'download_format_modal_All': '全部',
  'download_format_modal_data_only': '仅数据',
  'download_format_modal_more_statistics': '数据和更多统计',
}
